import { isIframe, iFrameSendMessage } from './iframe'
import VueScrollTo from 'vue-scrollto'

function preventPaste(e) {
  if (e.code == 'KeyV' && e.ctrlKey) {
    e.preventDefault()
    return false
  }
}

function log(...args) {
  if (!isProduction()) {
    //console.log(...args)
  }
}

function warn(...args) {
  if (!isProduction()) {
    //console.log(...args)
  }
}

function isProduction() {
  return true; 
}

function scrollTo(el, data) {
  data = data || { offset: -40 }
  if (isProduction()) {
    log('scrollTo', el, data)
  }
  if (!isIframe()) {
    VueScrollTo.scrollTo(el, 300, { offset: -40 })
  } else {
    let top = el.offsetTop
    iFrameSendMessage({ scrollTo: top - 40 })
  }
}

export { preventPaste, log, warn, isProduction, scrollTo }
